import IncrementsModel from '../Apis/Increments'
import Controller from './Controller'

export default class IncrementsController extends Controller {
  constructor() {
    super(new IncrementsModel())
  }
}
